/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Storage_Legajox_DescriptionInputs */

const es_settings_storage_legajox_description = /** @type {(inputs: Settings_Storage_Legajox_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox está integrado con tu organización. Nexy puede buscar documentos, consultar empleados, recibos de sueldo, ausencias y más directamente desde Legajox.`)
};

const en_settings_storage_legajox_description = /** @type {(inputs: Settings_Storage_Legajox_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox is integrated with your organization. Nexy can search documents, query employees, payroll, absences, and more directly from Legajox.`)
};

/**
* | output |
* | --- |
* | "Legajox is integrated with your organization. Nexy can search documents, query employees, payroll, absences, and more directly from Legajox." |
*
* @param {Settings_Storage_Legajox_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_storage_legajox_description = /** @type {((inputs?: Settings_Storage_Legajox_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Storage_Legajox_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_storage_legajox_description(inputs)
	return en_settings_storage_legajox_description(inputs)
});
export { settings_storage_legajox_description as "settings.storage.legajox_description" }